import { Link } from "react-router-dom";
import SectorHero from "@/components/SectorHero";
import ExpertiseGrid from "@/components/ExpertiseGrid";
import RealisationsGallery from "@/components/RealisationsGallery";
import ContactSection from "@/components/ContactSection";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { sectors } from "@/data/sectors";

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <SectorHero
        kicker="Nos solutions"
        title="Un écosystème technique au service de la performance énergétique."
        blurb="ECONATION couvre l'intégralité de la chaîne CEE : audit, étude, montage administratif, financement, travaux, mesure et vérification — pour chaque secteur, chaque usage, chaque échelle."
        image="https://images.unsplash.com/photo-1716643863806-989dd76ae093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODI3OTA2NDR8MA&ixlib=rb-4.1.0&q=85"
        tags={["Industrie", "Tertiaire", "Résidentiel", "Multi-sites", "Multi-techniques"]}
      />

      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
          <div className="max-w-3xl mb-14">
            <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Vos secteurs d&apos;activité</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">
              Choisissez votre univers, nous adaptons l&apos;intervention.
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 gap-6">
            {sectors.map((s) => (
              <article key={s.id} data-testid={`solution-card-${s.id}`} className="group bg-white border border-black/[0.06] rounded-2xl overflow-hidden hover:border-[#10B981]/40 hover:shadow-[0_30px_80px_-40px_rgba(15,23,42,0.25)] transition-all">
                <div className="aspect-[16/10] overflow-hidden bg-white">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-[1.2s]" />
                </div>
                <div className="p-7">
                  <div className="text-[11px] uppercase tracking-[0.24em] text-[#10B981] font-semibold mb-2">{s.kicker}</div>
                  <h3 className="font-display text-2xl font-bold text-[#0F172A] mb-3">{s.title}</h3>
                  <p className="text-sm text-[#475569] mb-6 leading-relaxed">{s.blurb}</p>
                  <ul className="space-y-1.5 mb-7">
                    {s.bullets.map((b) => (
                      <li key={b} className="text-sm text-[#475569] flex items-start gap-2">
                        <span className="h-1 w-1 rounded-full bg-[#10B981] mt-2 shrink-0" />
                        {b}
                      </li>
                    ))}
                  </ul>
                  <Link to={s.href} data-testid={`solution-link-${s.id}`}>
                    <Button className="w-full bg-white hover:bg-[#064E3B] text-white rounded-full">
                      Découvrir <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ExpertiseGrid kicker="Catalogue technique" title="14 domaines techniques, des centaines d'opérations CEE éligibles." />

      <RealisationsGallery limit={3} />

      <ContactSection />
    </div>
  );
}
